module.exports = __webpack_public_path__ + "img/venture-leader.bbe982b8.png";